<template>
  <view>
    <ul class="activity">
      <li @click="$jumpUrl('/pages/personalCenter/activity/detail')">
        <p class="title">
          <span>活动名称文字限制单行</span>
          <span class="golden font-12">预约成功</span>
        </p>
        <p>
          <span class="color-999 font-11">2020-6-28</span>
          <span class="font-11 color-999">查看详情</span>
        </p>
      </li>
      <li>
        <p class="title">
          <span>活动名称文字限制单行</span>
          <span class="golden font-12">预约成功</span>
        </p>
        <p>
          <span class="color-999 font-11">2020-6-28</span>
          <span class="font-11 color-999">查看详情</span>
        </p>
      </li>
    </ul>
  </view>
</template>

<script>
export default {
	data(){
		return{
			
		};
	}
};
</script>

<style lang="less" scoped>
.activity{
	overflow: hidden;
	padding:0 30upx;
	margin-top:30upx;
	li{
		padding:24upx 0;
		border-bottom:1px #D8D8D8 solid;
		p{
			display: flex;
			justify-content: space-between;
		}
		.title{
			margin-bottom:20upx;
		}
	}
	.golden{
		color:#C3986D;
	}
}
</style>
